<!-- 弹框内容-污染溯源 -->
<template>
  <div class="dialog-trace-source">
    <div class="header">
      <div class="title">{{ data.name }}</div>
      <!-- <span class="time">{{ data.updateDate }}</span> -->
      <!-- <span class="btn" @click="forecast">预测</span> -->
    </div>
    <div class="content">
      <div class="left">
        <div class="title">条件筛选</div>
        <div class="content">
          <div class="item">
            <span>河道范围</span>
            <n-select v-model:value="riverRange" size="small" :options="riverRanges" />
          </div>
          <div class="item">
            <span>上游范围</span>
            <n-select v-model:value="upperRange" size="small" :options="upperRanges" />
          </div>
          <div class="item">
            <span>下游范围</span>
            <n-select v-model:value="lowerRange" size="small" :options="lowerRanges" />
          </div>
          <div class="item">
            <span>开始时间</span>
            <n-date-picker v-model:value="beginTime" size="small" type="date" clearable />
          </div>
          <div class="item">
            <span>结束时间</span>
            <n-date-picker
              v-model:value="endTime"
              size="small"
              type="date"
              :on-update:value="endTimeChange"
              clearable
            />
          </div>
          <div class="item">
            <span>超标因子</span>
            <n-select
              v-model:value="cbFactor"
              size="small"
              :options="cbFactorList"
              @update:value="selectChange"
            />
          </div>
          <div class="item">
            <n-tree
              block-line
              cascade
              checkable
              :data="pointList"
              :checked-keys="treeChecked"
              :default-expanded-keys="defaultExpandedKeys"
              :on-update:checked-keys="updateCheckedKeys"
            />
          </div>
        </div>
      </div>
      <div id="wrsy-map" class="map">
        <div class="map-tools">
          <n-popover :overlap="overlap" :to="false" :delay="0" trigger="hover">
            <template #trigger>
              <span class="img-btn" @click="clickEvent('地图复位')"></span>
            </template>
            <span class="large-text">地图复位</span>
          </n-popover>
        </div>
      </div>

      <div class="right">
        <div class="top">
          <div class="top">
            <div class="title-parts2"></div>
            <div class="title-parts1"></div>
            <div class="title-parts2"></div>
          </div>
          <div class="content">
            <div class="title-parts3"></div>
            <div
              v-for="item in pageArr"
              :key="item"
              class="title"
              :class="{ active: pageContent === item }"
              @click="selectContent(item)"
            >
              {{ item }}
            </div>
          </div>
          <div class="bottom">
            <div class="title-parts2"></div>
            <div class="title-parts1"></div>
            <div class="title-parts2"></div>
          </div>
        </div>
        <div v-show="pageContent === '污染源异常报警'" class="content">
          <n-data-table
            max-height="658"
            style="width: 480px"
            :columns="columns1"
            :data="problemList1"
            :pagination="false"
            :bordered="false"
          />
        </div>
        <div v-show="pageContent === '水质异常报警'" class="content">
          <n-data-table
            max-height="658"
            style="width: 480px"
            :columns="columns2"
            :data="problemList2"
            :pagination="false"
            :bordered="false"
          />
        </div>
        <div v-show="pageContent === '巡查上报'" class="content">
          <n-data-table
            max-height="658"
            style="width: 480px"
            :columns="columns3"
            :data="problemList3"
            :pagination="false"
            :bordered="false"
          />
        </div>
      </div>
    </div>
    <!-- <Dialog ref="dialog" v-if="xxx">
      <img class="yc-img" src="~@/assets/img/cbyc.png" alt="">
    </Dialog> -->
  </div>
</template>

<script setup lang="ts">
import { watch, onMounted, h, computed } from 'vue'
import { ref } from 'vue-demi'
import { Api, wrsyQuery, wrsyProblemQuery, DotMapDto, WrsyProblemQuery } from '@/api/publicApi'
import { Api as ScreenSj } from '@/api/screenSj'
import { MapService } from '@/utils/mapServices2'
import Bus from '@/config/Bus'

const mapService2 = new MapService()
console.log('服务问题', mapService2)
const api = new Api()
const screenApi = new ScreenSj()
const props = defineProps({
  data: Object,
})
console.log(props.data)
// 河道范围
const riverRanges = ref([
  {
    value: 0.5,
    label: '0.5km',
  },
  {
    value: 1,
    label: '1km',
  },
  {
    value: 1.5,
    label: '1.5km',
  },
  {
    value: 2,
    label: '2km',
  },
  {
    value: 2.5,
    label: '2.5km',
  },
  {
    value: 3,
    label: '3km',
  },
])
// 上游范围
const upperRanges = ref([
  {
    value: 0.5,
    label: '0.5km',
  },
  {
    value: 1,
    label: '1km',
  },
  {
    value: 3,
    label: '3km',
  },
  {
    value: 5,
    label: '5km',
  },
  {
    value: 10,
    label: '10km',
  },
  {
    value: 15,
    label: '15km',
  },
  {
    value: 20,
    label: '20km',
  },
  {
    value: 30,
    label: '30km',
  },
  {
    value: 40,
    label: '40km',
  },
  {
    value: 50,
    label: '50km',
  },
])
// 下游范围
const lowerRanges = ref([
  {
    value: 0.5,
    label: '0.5km',
  },
  {
    value: 1,
    label: '1km',
  },
  {
    value: 3,
    label: '3km',
  },
  {
    value: 5,
    label: '5km',
  },
  {
    value: 10,
    label: '10km',
  },
  {
    value: 15,
    label: '15km',
  },
  {
    value: 20,
    label: '20km',
  },
  {
    value: 30,
    label: '30km',
  },
  {
    value: 40,
    label: '40km',
  },
  {
    value: 50,
    label: '50km',
  },
])
const riverRange = ref(0.5) // 河道范围
const upperRange = ref(5) // 上游范围
const lowerRange = ref(5) // 下游范围
const beginTime = ref(new Date(new Date() - 15 * 24 * 3600 * 1000))
const endTime = ref(new Date())
const cbFactor = ref('') // 超标因子
const emergencyDegree = ref(0) // 重要程度
const problemSource = ref(0) // 重要来源
const jd = ref('')
const wd = ref('')
const bufferRange = ref()
const cbFactorList = ref([]) // 超标因子下拉
const pointList = ref([])
const checkeds = ref([])
const problemList1 = ref([])
const problemList2 = ref([])
const problemList3 = ref([])
const pageContent = ref('水质异常报警')
const pageArr = ref(['污染源异常报警', '水质异常报警', '巡查上报'])
const tableData = ref([
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 3,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 2,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
  {
    problemName: '临江河红江闸坝断面高锰酸盐指数超标报警',
    problemTypeStr: '超标报警',
    reportTime: '2022-05-24',
    problemStatus: 1,
    problemTimes: 1,
  },
])
const columns1 = ref([
  {
    title: '问题描述',
    key: 'problemDesc',
    align: 'center',
    ellipsis: {
      tooltip: {
        trigger: 'click',
      },
      'line-clamp': 2,
    },
  },
  {
    title: '报警时间',
    key: 'boomTime',
    width: 120,
    align: 'center',
  },
  {
    title: '报警类别',
    key: 'boomType',
    width: 80,
    align: 'center',
  },
  {
    title: '报警次数',
    key: 'boomCount',
    width: 80,
    align: 'center',
  },
])
const columns2 = ref([
  // {
  //   title: '序号',
  //   key: 'no',
  //   width: 60,
  //   align: 'center',
  //   render(row, index) {
  //     return h(
  //       `span`,
  //       {},
  //       {
  //         default: () => index + 1,
  //       }
  //     )
  //   },
  // },
  {
    title: '问题描述',
    key: 'problemDesc',
    align: 'center',
    ellipsis: {
      tooltip: {
        trigger: 'click',
      },
      'line-clamp': 2,
    },
  },
  {
    title: '报警时间',
    key: 'boomTime',
    width: 120,
    align: 'center',
  },
  {
    title: '报警类别',
    key: 'boomType',
    width: 80,
    align: 'center',
  },
  {
    title: '报警次数',
    key: 'boomCount',
    width: 80,
    align: 'center',
  },

  // {
  //   title: '状态',
  //   key: 'problemStatus',
  //   width: 80,
  //   align: 'center',
  //   render(row, index) {
  //     let className = 'tag dcl'
  //     let content = '待处理'
  //     if (row.problemStatus === 1) {
  //       className = 'tag dcl'
  //       content = '待处理'
  //     }
  //     if (row.problemStatus === 2) {
  //       className = 'tag clz'
  //       content = '处理中'
  //     }
  //     if (row.problemStatus === 3) {
  //       className = 'tag ywj'
  //       content = '已办结'
  //     }
  //     return h(
  //       `div`,
  //       {
  //         class: className,
  //       },
  //       {
  //         default: () => content,
  //       }
  //     )
  //   },
  // },
])
const columns3 = ref([
  {
    title: '序号',
    key: 'no',
    width: 60,
    align: 'center',
    render(row: any, index: number) {
      return h(
        `span`,
        {},
        {
          default: () => index + 1,
        }
      )
    },
  },
  {
    title: '问题描述',
    key: 'problemName',
    align: 'center',
    ellipsis: {
      tooltip: {
        trigger: 'click',
      },
      'line-clamp': 2,
    },
  },
  {
    title: '类别',
    key: 'problemTypeStr',
    width: 80,
    align: 'center',
  },
  {
    title: '时间',
    key: 'reportTime',
    width: 120,
    align: 'center',
  },
  {
    title: '状态',
    key: 'problemStatus',
    width: 80,
    align: 'center',
    render(row: { problemStatus: number }, index: any) {
      let className = 'tag dcl'
      let content = '待处理'
      if (row.problemStatus === 1) {
        className = 'tag dcl'
        content = '待处理'
      }
      if (row.problemStatus === 2) {
        className = 'tag clz'
        content = '处理中'
      }
      if (row.problemStatus === 3) {
        className = 'tag ywj'
        content = '已办结'
      }
      return h(
        `div`,
        {
          class: className,
        },
        {
          default: () => content,
        }
      )
    },
  },
])

// yyyy-MM-dd格式的起始和结束时间
const formatBeginTime = computed(() => {
  return formatTime(beginTime.value)
})
const formatEndTime = computed(() => {
  return formatTime(endTime.value)
})
watch(beginTime, (newValue, oldValue) => {
  selectPoint()
  selectProblem()
})
watch(endTime, (newValue, oldValue) => {
  selectPoint()
  selectProblem()
})
watch(riverRange, (newValue, oldValue) => {
  selectPoint()
  selectProblem()
})
watch(upperRange, (newValue, oldValue) => {
  console.log(newValue, oldValue, 'upperRange')
  selectPoint()
  selectProblem()
})
watch(lowerRange, (newValue, oldValue) => {
  selectPoint()
  selectProblem()
})

const getCbFactorUsingGet = () => {
  api.screen.getCbFactorUsingGet().then((res) => {
    if (res.code === 200) {
      cbFactor.value = res.data[0].name
      if (!props.data.selectFactor) {
        cbFactor.value = res.data[0].name
      }
      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i].name == props.data.selectFactor) {
          cbFactor.value = props.data.selectFactor
        }
        res.data[i].label = res.data[i].name
      }
      cbFactorList.value = res.data
    }
  })
}
getCbFactorUsingGet()

const formatTime = (val: {
  toString: () => string
  toDateString: () => string
  toTimeString: () => string
  toLocaleString: {
    (): string
    (
      locales?: string | string[] | undefined,
      options?: Intl.DateTimeFormatOptions | undefined
    ): string
    (locales?: Intl.LocalesArgument, options?: Intl.DateTimeFormatOptions | undefined): string
  }
  toLocaleDateString: {
    (): string
    (
      locales?: string | string[] | undefined,
      options?: Intl.DateTimeFormatOptions | undefined
    ): string
    (locales?: Intl.LocalesArgument, options?: Intl.DateTimeFormatOptions | undefined): string
  }
  toLocaleTimeString: {
    (): string
    (
      locales?: string | string[] | undefined,
      options?: Intl.DateTimeFormatOptions | undefined
    ): string
    (locales?: Intl.LocalesArgument, options?: Intl.DateTimeFormatOptions | undefined): string
  }
  valueOf: () => number
  getTime: () => number
  getFullYear: () => number
  getUTCFullYear: () => number
  getMonth: () => number
  getUTCMonth: () => number
  getDate: () => number
  getUTCDate: () => number
  getDay: () => number
  getUTCDay: () => number
  getHours: () => number
  getUTCHours: () => number
  getMinutes: () => number
  getUTCMinutes: () => number
  getSeconds: () => number
  getUTCSeconds: () => number
  getMilliseconds: () => number
  getUTCMilliseconds: () => number
  getTimezoneOffset: () => number
  setTime: (time: number) => number
  setMilliseconds: (ms: number) => number
  setUTCMilliseconds: (ms: number) => number
  setSeconds: (sec: number, ms?: number | undefined) => number
  setUTCSeconds: (sec: number, ms?: number | undefined) => number
  setMinutes: (min: number, sec?: number | undefined, ms?: number | undefined) => number
  setUTCMinutes: (min: number, sec?: number | undefined, ms?: number | undefined) => number
  setHours: (
    hours: number,
    min?: number | undefined,
    sec?: number | undefined,
    ms?: number | undefined
  ) => number
  setUTCHours: (
    hours: number,
    min?: number | undefined,
    sec?: number | undefined,
    ms?: number | undefined
  ) => number
  setDate: (date: number) => number
  setUTCDate: (date: number) => number
  setMonth: (month: number, date?: number | undefined) => number
  setUTCMonth: (month: number, date?: number | undefined) => number
  setFullYear: (year: number, month?: number | undefined, date?: number | undefined) => number
  setUTCFullYear: (year: number, month?: number | undefined, date?: number | undefined) => number
  toUTCString: () => string
  toISOString: () => string
  toJSON: (key?: any) => string
  getVarDate: () => VarDate
  [Symbol.toPrimitive]: {
    (hint: 'default'): string
    (hint: 'string'): string
    (hint: 'number'): number
    (hint: string): string | number
  }
}) => {
  let res = ''
  if (val instanceof Date) {
    const year = val.getFullYear()
    let month = val.getMonth() + 1
    let day = val.getDate()
    if (month < 10) {
      month = `0${month}`
    }
    if (day < 10) {
      day = `0${day}`
    }
    res = `${year}-${month}-${day}`
  }
  return res
}

const endTimeChange = (time: string | number | Date) => {
  // let timeArr = time.split('-')
  // let now = new Date(timeArr[0], timeArr[1]-1, timeArr[2])
  // let now = new Date(timeArr[0], timeArr[1]-1, timeArr[2])
  const day15ago = new Date(time - 15 * 24 * 3600 * 1000)
  beginTime.value = day15ago
  endTime.value = new Date(time)
}

const selectContent = (val: string) => {
  pageContent.value = val
  selectProblem()
}

const initmap = () => {
  mapService2.initMap(
    {
      container: 'wrsy-map',
      style: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/ht新河长大屏-详情.json',
      center: [
        props.data.longitude ? parseFloat(props.data.longitude) : parseFloat(props.data.jd),
        props.data.latitude ? parseFloat(props.data.latitude) : parseFloat(props.data.wd),
      ],
      zoom: 12,
      minZoom: 9.5,
      bearing: -11.799999999999704,
      antialias: true,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA',
    this
  )
  mapService2.map.once('styledata', () => {
    /* eslint-disable */
    mapService2.addImage(require('@/assets/img/map/riverDetails.png'), 'riverDetails.png')
    setTimeout(() => {
      selectPoint()
      selectProblem()
    }, 2000)
  })
}
// 点位搜索
const selectPoint = () => {
  mapService2.removeLayer('problemPoint')
  mapService2.removeLayer('origin')
  bufferRange.value = mapService2.getBufferRange(
    [
      props.data.longitude ? parseFloat(props.data.longitude) : parseFloat(props.data.jd),
      props.data.latitude ? parseFloat(props.data.latitude) : parseFloat(props.data.wd),
    ],
    riverRange.value,
    upperRange.value,
    lowerRange.value
  )
  mapService2.addCirclePointsLayer('origin', [bufferRange.value.origin], 4)
  console.log(bufferRange.value, 'bufferRange')
  getPointList()
  const bbox = getBbox(bufferRange.value.polygon.geometry.coordinates)
  mapService2.fitBounds(bbox)
  mapService2.drawBufferRange(bufferRange.value.polygon)
}

// 获取范围两角坐标
const getBbox = (data: [undefined, any][][]) => {
  let minLng = data[0][0][0]
  let maxLng = data[0][0][0]
  let minLat = data[0][0][1]
  let maxLat = data[0][0][1]
  for (let i = 0; i < data[0].length; i += 1) {
    if (data[0][i][0] < minLng) {
      ;[minLng] = data[0][i]
    } else if (data[0][i][0] > maxLng) {
      ;[maxLng] = data[0][i]
    }
    if (data[0][i][1] < minLat) {
      ;[, minLat] = data[0][i]
    }
    if (data[0][i][1] > maxLat) {
      ;[, maxLat] = data[0][i]
    }
  }
  return [
    [minLng, minLat],
    [maxLng, maxLat],
  ]
}

const getMapIcon2 = (data: DotMapDto) => {
  let icon = ''
  let modalType = ''
  switch (data.categoryStr) {
    case '一体化水质自动监测站':
      modalType = '自动监测断面'
      if (data.gkjb) {
        if (data.gkjb === '区县控') {
          icon = '区控'
        } else {
          icon = data.gkjb
        }
      }
      break
    case '物联型水质自动监测站':
      modalType = '自动监测断面'
      if (data.gkjb) {
        if (data.gkjb === '区县控') {
          icon = '区控'
        } else {
          icon = data.gkjb
        }
      }
      break
  }
  switch (icon) {
    case '区控':
    case '市控':
    case '国控':
    case '一体化':
      icon = icon + '_1类'
      break
    default:
      if (data.online) {
        // 是否在线
        if (data.standard) {
          // 是否超标
          if (data.standard === 'cb') {
            icon = `${icon}_1`
          }
          if (data.standard === 'wsj') {
            icon = `${icon}_0`
          }
        }
      }
  }
  icon = `${icon}.png`
  return { ...data, icon, modalType }
}

const getMapIcon = (type: string | undefined, data: DotMapDto) => {
  let icon = ''
  let modalType = ''
  switch (type) {
    case '手工监测站':
      modalType = '手工监测断面'
      if (data.gkjb) {
        if (data.gkjb === '区县控') {
          icon = '区控'
        } else {
          icon = data.gkjb
        }
      }
      break
    case '一体化自动站':
      modalType = '自动监测断面'
      icon = '一体化'
      break
    case '物联站':
      icon = '物联'
      modalType = '自动监测断面'
      break
    case '重点工业企业':
      icon = '工业企业'
      modalType = '工业企业'
      break
    case '畜牧养殖':
      icon = '畜禽养殖场'
      modalType = 'gmhxmyz'
      break
    case '水产养殖':
      icon = '水产养殖场'
      modalType = 'scyz'
      break
    case '污水处理厂':
      icon = '污水厂'
      modalType = '污水处理厂'
      break
    case '农贸市场':
      icon = '农贸市场'
      modalType = '农贸市场'
      break
    case '水文站':
      icon = '水文站'
      modalType = '水文站'
      break
    case '水位站':
      icon = '水位站'
      modalType = '水文站'
      break
    case '雨量站':
      icon = '雨量站'
      modalType = '水文站'
      break
    default:
  }
  switch (icon) {
    case '区控':
    case '市控':
    case '国控':
    case '一体化':
      icon = icon + '_1类'
      break
    default:
      if (data.online) {
        // 是否在线
        if (data.standard) {
          // 是否超标
          if (data.standard === 'cb') {
            icon = `${icon}_1`
          }
          if (data.standard === 'wsj') {
            icon = `${icon}_0`
          }
        }
      }
  }

  icon = `${icon}.png`
  return { ...data, icon, modalType }
}

//--------------------------------------点位筛选树-----------------------------------------

const defaultExpandedKeys = ref([])

// 获取点位
const getPointList = () => {
  const [...layers] = mapService2.map.getStyle().layers
  console.log(layers, 'layers')
  for (let i = 0; i < layers.length; i += 1) {
    if (layers[i].id.indexOf('_point') >= 0) {
      mapService2.removeLayer(layers[i].id)
    }
  }
  treeChecked.value = []
  const params: wrsyQuery = {
    beginTime: format(beginTime.value),
    endTime: format(endTime.value),
    points: bufferRange.value.line.geometry.coordinates,
    cbFactor: cbFactor.value,
    scope: riverRange.value * 1000,
  }
  api.screen.getWrsyPointListUsingPost(params).then((res) => {
    defaultExpandedKeys.value = []
    pointList.value = res.data.map((item) => {
      // defaultExpandedKeys.value.push(item.name) // 默认展开
      return {
        label: `${item.name} (${item.count})`,
        key: item.name,
        isChild: false,
        children: item.datas?.map((i, index) => {
          // 添加点位图层
          const data = []
          let cb = 0
          for (let n = 0; n < i.datas.length; n += 1) {
            if (i.datas[n].standard === 'cb') {
              cb += 1
            }
            data.push({
              coordinates: [parseFloat(i.datas[n].jd), parseFloat(i.datas[n].wd)],
              properties: {
                ...getMapIcon(i.name, i.datas[n]),
                visibility: 'none',
              },
            })
          }
          mapService2.addPointsLayer(`${i.name}_point`, data, '', 1)
          //默认隐藏
          mapService2.hideLayer(`${i.name}_point`)
          return {
            label: `${i.name} (${i.count})`,
            key: i.name,
            isChild: true,
            ...i,
          }
        }),
      }
    })
    const list = [];
    pointList.value.forEach(item => {
      if (item && item.key === '水质站') {
        list.push(item.key)
        if (item.children && item.children.length) {
          item.children.forEach(item2 => {
            list.push(item2.key)
          })
        }
      }
    })
    updateCheckedKeys(list)
  })
}
const treeChecked = ref<string | any[]>([])
const updateCheckedKeys = (keys: string | any[], options: any, meta: any) => {
  console.log('updateCheckedKeys', keys, options, meta)
  treeChecked.value = keys

  pointList.value.forEach((item) => {
    item.children.forEach((i: { name: any }) => {
      if (keys.includes(i.name)) {
        mapService2.showLayer(`${i.name}_point`)
      } else {
        mapService2.hideLayer(`${i.name}_point`)
      }
    })
  })
  if (keys.length > 0) {
    mapService2.hideLayer('szProblemPoint')
  } else {
    mapService2.showLayer('szProblemPoint')
  }
}

// 问题搜索
const selectProblem = () => {
  mapService2.removeLayer('problemPoint')
  const params: wrsyProblemQuery = {
    beginTime: format(beginTime.value),
    endTime: format(endTime.value),
    points: bufferRange.value.line.geometry.coordinates,
    emergencyDegree: 0,
    // problemSource: 0,
    cbFactor: cbFactor.value,
    jd: props.data.longitude ? parseFloat(props.data.longitude) : parseFloat(props.data.jd),
    wd: props.data.latitude ? parseFloat(props.data.latitude) : parseFloat(props.data.wd),
    syfw: upperRange.value * 1000,
    xyfw: lowerRange.value * 1000,
    scope: riverRange.value * 1000,
  }
  switch (pageContent.value) {
    case '污染源异常报警':
      getWrsyBoomListUsingPost(params)
      break
    case '水质异常报警':
      getWrsySzBoomListUsingPost(params)
      break
    case '巡查上报':
      getWrsyProblemListUsingPost(params)
      break
  }
}

//水质异常报警清单
const szProblemDotMapList = ref([])
const getWrsySzBoomListUsingPost = (params: WrsyProblemQuery) => {
  console.log(2, 'getWrsySzBoomListUsingPost')
  screenApi.screen.getWrsyBoomListUsingPost(params).then((res) => {
    szProblemDotMapList.value = []
    problemList2.value = res.data?.map((item) => {
      szProblemDotMapList.value.push({
        coordinates: [parseFloat(item.dotMap.jd), parseFloat(item.dotMap.wd)],
        properties: {
          ...getMapIcon2(item.dotMap),
        },
      })
      return {
        ...item,
      }
    })
    console.log(szProblemDotMapList.value, 'szProblemDotMapList.value')
    mapService2.removeLayer('szProblemPoint')
    mapService2.addPointsLayer('szProblemPoint', szProblemDotMapList.value, '', 1)
  })
}

//污染源异常报警青清单
const wrsyPointList = ref([])
const getWrsyBoomListUsingPost = (params) => {
  console.log(1, 'getWrsyBoomListUsingPost')
  wrsyPointList.value = []
  screenApi.screen.getWrsySzBoomListUsingPost(params).then((res) => {
    problemList1.value = res.data?.map((item) => {
      wrsyPointList.value.push({
        ...item.data[0],
        jd: item.jd,
        wd: item.wd,
        type: item.boomType,
      })
      return {
        ...item,
      }
    })
    showWrsyPoint()
  })
}
const showWrsyPoint = () => {
  const datas = wrsyPointList.value.map((item) => {
    return {
      coordinates: [parseFloat(item.jd), parseFloat(item.wd)],
      properties: {
        modalType: '问题详情',
        icon: 'riverDetails.png',
        category: 'zdgj',
        ...item,
      },
    }
  })
  mapService2.removeLayer('wrsyProblemPoints')
  mapService2.addPointsLayer('wrsyProblemPoints', datas, '', 1)
}
//问题列表
const getWrsyProblemListUsingPost = (params: WrsyProblemQuery) => {
  console.log(3, 'getWrsyProblemListUsingPost')
  api.screen.getWrsyProblemListUsingPost(params).then((res) => {
    problemList3.value = res.data
  })
}

// 点管理
const pointsManage = (e: any, data: string | any[]) => {
  console.log('pointsManage', e, data)
  if (e) {
    for (let i = 0; i < data.length; i += 1) {
      mapService2.showLayer(`${data[i].name}_point`)
    }
  } else {
    for (let i = 0; i < data.length; i += 1) {
      mapService2.hideLayer(`${data[i].name}_point`)
    }
  }
}

// 点击问题
const clickProblem = (data: { longitude: any; latitude: any; category: string; deviceMn: any }) => {
  let properties = {
    ...data,
    jd: data.longitude,
    wd: data.latitude,
  }
  if (data.category != 'xcsb') {
    properties.id = data.deviceMn
  }
  // Bus.emit('mapClick2', { properties: properties })
}

const selectChange = (val: any) => {
  selectPoint()
  selectProblem()
}

const clickEvent = (val: any) => {
  switch (val) {
    case '地图复位':
      mapService2.flyTo({
        center: [parseFloat(props.data.longitude), parseFloat(props.data.latitude)],
        zoom: 12,
      })
      break
  }
}

const mapClick = (data: unknown) => {
  Bus.emit('mapClick2', data)
}

const forecast = () => {
  if (props.data.name === '茨坝') {
    // Bus.emit('mapClick2', { data: { category: 'yc' }, modalType: 'yc' })
  }
}

function add0(m: string | number) {
  return m < 10 ? '0' + m : m
}
function format(shijianchuo: string | number | Date) {
  //shijianchuo是整数，否则要parseInt转换
  var time = new Date(shijianchuo)
  var y = time.getFullYear()
  var m = time.getMonth() + 1
  var d = time.getDate()
  // var h = time.getHours();
  // var mm = time.getMinutes();
  // var s = time.getSeconds();
  // return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
  return y + '-' + add0(m) + '-' + add0(d)
}

onMounted(() => {
  initmap()
})
</script>

<style lang="scss" scoped>
.dialog-trace-source {
  text-align: left;
  font-family: 'SimHei';
  .header {
    padding-bottom: 2rem;
    position: relative;
    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 3.15rem;
      line-height: 3.15rem;
    }
    .time {
      margin-top: 1.2rem;
      display: inline-block;
    }
    .btn {
      font-size: 1.6rem;
      position: absolute;
      right: 0;
      bottom: 1.5rem;
      border: 1px solid #4cb1db;
      padding: 0.4rem 0.9rem;
      border-radius: 0.4rem;
      cursor: pointer;
    }
  }
  & > .content {
    display: flex;
    .left {
      width: 24.8rem;
      // background: #279ad3;
      background: #00d4ff4d;
      border-radius: 1rem;
      overflow: hidden;
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 1rem 0;
        color: #d9f5ff;
        span {
          font-size: 1.3rem;
          flex: 0 0 65px;
        }
        .list {
          width: 100%;
          list-style: none;
          padding-left: 0.5rem;
          ul {
            padding: 10px;
          }
          li {
            list-style: none;
            div {
              display: flex;
              align-items: center;
              height: 3rem;
              .icon {
                flex: 0 0 15px;
                height: 15px;
                background-repeat: no-repeat;
                background-size: 100% 100%;
              }
              .icon-wlz {
                background-image: url('~@/assets/img/map/物联站.png');
              }
              .icon-sgjcz {
                background-image: url('~@/assets/img/map/手工监测站.png');
              }
              .icon-ytzdz {
                background-image: url('~@/assets/img/map/一体自动站.png');
              }
              .icon-yz {
                background-image: url('~@/assets/img/map/养殖.png');
              }
              .icon-zdgyqy {
                background-image: url('~@/assets/img/map/重点工业企业.png');
              }
              .icon-ybgyqy {
                background-image: url('~@/assets/img/map/一般工业企业.png');
              }
              .icon-wsclc {
                background-image: url('~@/assets/img/map/污水处理厂icon.png');
              }
              .icon-zdpsh {
                background-image: url('~@/assets/img/map/重点排水户.png');
              }
              .name {
                flex: 0 0 100px;
                margin-left: 1rem;
                text-decoration: underline;
              }
              .total {
                flex: 0 0 40px;
                color: #00c1ff;
              }
              .abnormal {
                flex: 0 0 40px;
                color: #dd9090;
                padding-left: 1.5rem;
              }
            }
          }
        }
      }
      .title {
        line-height: 4rem;
        font-size: 1.6rem;
        // background: #1575b9;
        background: #243be654;
        padding: 1rem;
        font-weight: 700;
      }
      & > .content {
        padding: 1rem;
        height: 685px;
        overflow: auto;
      }
    }
    .map {
      width: 980px;
      margin: 0 1rem;
      height: 76.7rem;
      :deep(.mapboxgl-ctrl-logo) {
        display: none;
      }
    }
    .map-tools {
      position: absolute;
      right: 20px;
      bottom: 10px;
      display: flex;
      z-index: 10;
      .disable {
        cursor: no-drop !important;
      }
      // flex-direction: column;
      .img-btn {
        display: inline-block;
        width: 36px;
        height: 36px;
        margin: 0 5px;
        cursor: pointer;
        &:nth-of-type(1) {
          background-image: url('@/assets/img/map/地图复位.png');
        }
      }
      :deep(.n-popover) {
        background: #ffffff;
        padding: 5px 6px !important;
        font-size: 12px;
        line-height: 12px;
        .n-popover__content {
          .large-text {
            color: #000000;
            white-space: nowrap;
          }
        }
        .n-popover-arrow-wrapper {
          .n-popover-arrow {
            background: #ffffff;
          }
        }
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      .top {
        .top {
          display: flex;
          height: 0.1rem;
          .title-parts1 {
            flex: 1;
            height: 100%;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-image: url('~@/assets/img/map/title-parts1.png');
          }
          .title-parts2 {
            width: 0.75rem;
            height: 100%;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-image: url('~@/assets/img/map/title-parts2.png');
          }
        }
        .bottom {
          display: flex;
          height: 0.1rem;
          .title-parts1 {
            flex: 1;
            height: 100%;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-image: url('~@/assets/img/map/title-parts1.png');
          }
          .title-parts2 {
            width: 0.75rem;
            height: 100%;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-image: url('~@/assets/img/map/title-parts2.png');
          }
        }
        .content {
          display: flex;
          align-items: center;
          min-width: 515px;
          .title-parts3 {
            width: 1.5rem;
            height: 3rem;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-image: url('~@/assets/img/map/title-parts3.png');
          }
          .title {
            box-sizing: border-box;
            font-size: 1.8rem;
            // padding-right: 4rem;
            padding: 1.5rem 2rem;
            position: relative;
            cursor: pointer;
            &.active {
              font-size: 2.6rem;
              &::after {
                content: '';
                position: absolute;
                bottom: 0;
                height: 0.2rem;
                background-color: #fff;
                width: 65%;
                left: 50%;
                transform: translateX(-50%);
              }
            }
          }
        }
      }
      .content {
        :deep(.n-data-table-base-table-body) {
          height: 658px !important;
        }
        :deep(.n-data-table-empty) {
          height: 658px !important;
        }
        // background: #0e5aa9;
        background: #243be654;
        position: relative;
        .title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 1.5rem;
          h5 {
            font-size: 1.6rem;
            margin: 0;
            padding: 0;
          }
        }
        :deep(.n-data-table) {
          width: 600px;
          margin: 0 auto;
          --n-border-color-modal: #ffffff00 !important;
          --n-th-color-modal: #ffffff00 !important;
          --n-td-color-hover-modal: #ffffff00 !important;
          --n-td-color-modal: #ffffff00 !important;
          tbody {
            tr:nth-of-type(odd) {
              background: #ffffff0d;
            }
            tr:hover {
              background: #ffffff26;
            }
            td {
              padding: 5px 5px 0 5px;
            }
            .tag {
              color: #000000;
              padding: 0;
              text-align: center;
              width: 4rem;
              border-radius: 0.25rem;
              margin: auto;
              font-size: 1rem;
            }
            .clz {
              background: #ffe3c2;
            }
            .dcl {
              background: #f7d4d4;
            }
            .ywj {
              background: #bfe7ff;
            }
          }
        }
      }
    }
  }
}
</style>
